export default __webpack_public_path__ + "mask4cc1c50.png";